import { render, staticRenderFns } from "./FilterSwitch.vue?vue&type=template&id=008e3445&scoped=true&"
import script from "./FilterSwitch.vue?vue&type=script&lang=js&"
export * from "./FilterSwitch.vue?vue&type=script&lang=js&"
import style0 from "./FilterSwitch.vue?vue&type=style&index=0&id=008e3445&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008e3445",
  null
  
)

export default component.exports